import axios from 'axios'
// import rg4js from 'raygun4js'
import { v4 as uuidv4 } from 'uuid'

export const state = {
  uuid: null
}

export const getters = {
  getUuid: state => state.uuid
}

export const mutations = {
  SET_UUID (state, value) {
    state.uuid = value
  }
}

export const actions = {
  async startSession (context, campaignData) {
    const uuid = uuidv4()
    context.commit('SET_UUID', {
      uuid
    })
    try {
      const url = process.env.VUE_APP_SESSION_WAREHOUSE_URL

      await axios.post(`${url}/startsession`, {
        uuid,
        campaignData
      })
    } catch (error) {
      console.log(error)
    }
  },
  // DROPOUTS
  async updateSessionsWarehouse (context, data) {
    try {
      const url = process.env.VUE_APP_SESSION_WAREHOUSE_URL

      await axios.post(`${url}/sessionwarehouse`, {
        // uuid
        data
      })
    } catch (error) {
      console.log(error)
    }
  },
  // LEAD
  async sessionsWarehouseLead ({ rootGetters }, { uuid, callbackData }) {
    try {
      const url = process.env.VUE_APP_SESSION_WAREHOUSE_URL

      await axios.post(`${url}/lead`, {
        ...uuid,
        data: {
          leadsNotes: rootGetters.leadNotes.substring(0, 500),
          callbackData
        }
      })
      // console.log('updating', { uuid, leadsNotes, callbackData });
    } catch (error) {
      console.log(error)
    }
  }
}
